<div class="image-cropper-container">
  <!-- <div class="button-groups-container">
    <button (click)="btnCancelClicked()">Cancel</button>
  </div> -->
  <!-- -->
  <image-cropper [imageBase64]="webcamImage" [maintainAspectRatio]="true" [aspectRatio]="3/4"
    [resizeToWidth]="photoWidth>2048?2048:''" format="png" (imageCropped)="imageCropped($event)"
    (imageLoaded)="imageLoaded()" (cropperReady)="cropperReady()" (loadImageFailed)="loadImageFailed()"></image-cropper>
</div>
